// // @ts-nocheck
// import { Column } from 'react-table'
// import { UserInfoCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserInfoCell'
// import { UserLastLoginCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserLastLoginCell'
// import { UserTwoStepsCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserTwoStepsCell'
// import { UserActionsCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserActionsCell'
// import { UserSelectionCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserSelectionCell'
// import { UserCustomHeader } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserCustomHeader'
// import { UserSelectionHeader } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserSelectionHeader'
// import { boolean } from 'yup'
// import { UserPopularCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserPopularCell'

// const generator = (data) => {
//   return data.map((eachHeader, idx) => {
//     if (eachHeader.label === 'certificate_view') {
//       return {
//         Header: (props) => (
//           <UserCustomHeader tableProps={props} title={'Certificate'} className=' min-w-100px' />
//         ),
//         id: idx + 1 + '',
//         Cell: ({ ...props }) => {
//           return props?.data[props.row.index]?.status === 'Completed' ? (
//             <UserActionsCell id={props.data[props.row.index].id} action={['view']} />
//           ) : null
//         },
//       }
//     } else if (eachHeader?.action?.length > 0) {
//       return {
//         Header: (props) => (
//           <UserCustomHeader
//             tableProps={props}
//             title={eachHeader.action.includes('certificate') ? 'Certificate' : 'Actions'}
//             className=' min-w-100px'
//           />
//         ),
//         id: idx + 1 + '',
//         Cell: ({ ...props }) => {
//           const rowData = props.data[props.row.index];
//           const currentPath = window.location.pathname;

//           // For quality-assessment path, only show edit action if status is DISPATCHED
//           if (currentPath === '/apps/transactions/quality-assessment' && eachHeader.action.includes('edit')) {
//             return (
//               <UserActionsCell
//                 allData={rowData}
//                 id={eachHeader?.action.includes('id') ? rowData.id : rowData}
//                 action={rowData.status === 'DISPATCHED' ? ['edit'] : []}
//               />
//             )
//           }


//           // For supply-orders2 path, only show edit action if status is DISPATCHED
//           if (currentPath === '/apps/finance/supply-orders2' && eachHeader.action.includes('edit')) {
//             return (
//               <UserActionsCell
//                 allData={rowData}
//                 id={eachHeader?.action.includes('id') ? rowData.id : rowData}
//                 action={rowData.status === 'DISPATCHED' ? ['edit'] : []}
//               />
//             )
//           }



//           return (
//             <UserActionsCell
//               allData={props.data[props.row.index]}
//               id={
//                 eachHeader?.action.includes('id')
//                   ? props.data[props.row.index].id
//                   : props.data[props.row.index]
//               }
//               action={eachHeader?.action}
//             />
//           )
//         },
//       }
//     } else
//       return {
//         Header: (props) => {
//           const currentPath = window.location.pathname;

//           // Check if the current path is any of the supply orders pages
//           const isSupplyOrdersPage = [
//             '/apps/finance/supply-orders2',
//             '/apps/logic/supply-orders',
//             '/apps/purchase/supply-orders',
//             '/apps/sales/supply-orders'
//           ].includes(currentPath);

//           // Only apply special handling on supply orders pages
//           if (isSupplyOrdersPage) {
//             // Reduced width for Qty, Item, and Date columns
//             if (eachHeader.label === 'Qty' || eachHeader.label === 'Item' ||
//               eachHeader.label === 'qty' || eachHeader.label === 'item' ||
//               eachHeader.label === 'Date' || eachHeader.label === 'date') {
//               return (
//                 <UserCustomHeader
//                   tableProps={props}
//                   title={eachHeader.label}
//                   className="min-w-50px !w-50px"
//                 />
//               )
//             }

//             // Increased width for Supply Partner column
//             if (eachHeader.label === 'Supply partner' || eachHeader.label === 'Supply Partner') {
//               return (
//                 <UserCustomHeader
//                   tableProps={props}
//                   title={eachHeader.label}
//                   className="min-w-200px !w-200px"
//                 />
//               )
//             }
//           }

//           // Default column width handling
//           return (
//             <UserCustomHeader
//               tableProps={props}
//               title={eachHeader.label}
//               className={
//                 ['S.N', 'ID'].includes(eachHeader.label)
//                   ? 'min-w-25px'
//                   : eachHeader.label === 'Recycler'
//                     ? 'min-w-150px'
//                     : 'min-w-125px'
//               }
//             />
//           )
//         },
//         id: idx + 1 + '',
//         Cell: ({ ...props }) => {
//           return ['S.N', 'ID'].includes(eachHeader.label) ? (
//             props.row.index + 1
//           ) : eachHeader?.label?.toLowerCase() === 'popular' ? (
//             <UserPopularCell
//               flag={props.data[props.row.index][eachHeader?.value] || false}
//               id={props.data[props.row.index].id}
//             />
//           ) : (
//             <UserInfoCell
//               mapData={eachHeader.value}
//               user={props.data[props.row.index]}
//               showImageOnly={eachHeader.value === 'avatar'}
//             />
//           )
//         },
//       }
//   })
// }

// // const columnGenerators: ReadonlyArray<Column<User>> = generator()
// const columnGenerators = (header) => {
//   return generator(header)
// }

// export { columnGenerators }























// // @ts-nocheck
// import { Column } from 'react-table'
// import { UserInfoCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserInfoCell'
// import { UserLastLoginCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserLastLoginCell'
// import { UserTwoStepsCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserTwoStepsCell'
// import { UserActionsCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserActionsCell'
// import { UserSelectionCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserSelectionCell'
// import { UserCustomHeader } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserCustomHeader'
// import { UserSelectionHeader } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserSelectionHeader'
// import { boolean } from 'yup'
// import { UserPopularCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserPopularCell'

// const generator = (data) => {
//   return data.map((eachHeader, idx) => {
//     if (eachHeader.label === 'certificate_view') {
//       return {
//         Header: (props) => (
//           <UserCustomHeader tableProps={props} title={'Certificate'} className=' min-w-100px' />
//         ),
//         id: idx + 1 + '',
//         Cell: ({ ...props }) => {
//           return props?.data[props.row.index]?.status === 'Completed' ? (
//             <UserActionsCell id={props.data[props.row.index].id} action={['view']} />
//           ) : null
//         },
//       }
//     } else if (eachHeader?.action?.length > 0) {
//       return {
//         Header: (props) => (
//           <UserCustomHeader
//             tableProps={props}
//             title={eachHeader.action.includes('certificate') ? 'Certificate' : 'Actions'}
//             className=' min-w-100px'
//           />
//         ),
//         id: idx + 1 + '',
//         Cell: ({ ...props }) => {
//           const rowData = props.data[props.row.index];
//           const currentPath = window.location.pathname;

//           // For quality-assessment path, only show edit action if status is DISPATCHED
//           if (currentPath === '/apps/transactions/quality-assessment' && eachHeader.action.includes('edit')) {
//             return (
//               <UserActionsCell
//                 allData={rowData}
//                 id={eachHeader?.action.includes('id') ? rowData.id : rowData}
//                 action={rowData.status === 'DISPATCHED' ? ['edit'] : []}
//               />
//             )
//           }

//           // For supply-orders2 path, only show edit action if status is DISPATCHED
//           if (currentPath === '/apps/finance/supply-orders2' && eachHeader.action.includes('edit')) {
//             return (
//               <UserActionsCell
//                 allData={rowData}
//                 id={eachHeader?.action.includes('id') ? rowData.id : rowData}
//                 action={rowData.status === 'DISPATCHED' ? ['edit'] : []}
//               />
//             )
//           }

//           // For business collection-point path, only show edit for ACTIVE status
//           if (currentPath === '/apps/business/collection-point' && eachHeader.action.includes('edit')) {
//             return (
//               <UserActionsCell
//                 allData={rowData}
//                 id={eachHeader?.action.includes('id') ? rowData.id : rowData}
//                 action={rowData.status === 'ACTIVE' ? ['edit', 'delete'] : ['delete']}
//               />
//             )
//           }

//           // For finance collection-point path, only show edit for INACTIVE status
//           if (currentPath === '/apps/finance/collection-point' && eachHeader.action.includes('edit')) {
//             return (
//               <UserActionsCell
//                 allData={rowData}
//                 id={eachHeader?.action.includes('id') ? rowData.id : rowData}
//                 action={rowData.status !== 'ACTIVE' ? ['edit', 'delete'] : ['delete']}
//               />
//             )
//           }

//           return (
//             <UserActionsCell
//               allData={props.data[props.row.index]}
//               id={
//                 eachHeader?.action.includes('id')
//                   ? props.data[props.row.index].id
//                   : props.data[props.row.index]
//               }
//               action={eachHeader?.action}
//             />
//           )
//         },
//       }
//     } else
//       return {
//         Header: (props) => {
//           const currentPath = window.location.pathname;

//           // Check if the current path is any of the supply orders pages
//           const isSupplyOrdersPage = [
//             '/apps/finance/supply-orders2',
//             '/apps/logic/supply-orders',
//             '/apps/purchase/supply-orders',
//             '/apps/sales/supply-orders'
//           ].includes(currentPath);

//           // Only apply special handling on supply orders pages
//           if (isSupplyOrdersPage) {
//             // Reduced width for Qty, Item, and Date columns
//             if (eachHeader.label === 'Qty' || eachHeader.label === 'Item' ||
//               eachHeader.label === 'qty' || eachHeader.label === 'item' ||
//               eachHeader.label === 'Date' || eachHeader.label === 'date') {
//               return (
//                 <UserCustomHeader
//                   tableProps={props}
//                   title={eachHeader.label}
//                   className="min-w-50px !w-50px"
//                 />
//               )
//             }

//             // Increased width for Supply Partner column
//             if (eachHeader.label === 'Supply partner' || eachHeader.label === 'Supply Partner') {
//               return (
//                 <UserCustomHeader
//                   tableProps={props}
//                   title={eachHeader.label}
//                   className="min-w-200px !w-200px"
//                 />
//               )
//             }
//           }

//           // Default column width handling
//           return (
//             <UserCustomHeader
//               tableProps={props}
//               title={eachHeader.label}
//               className={
//                 ['S.N', 'ID'].includes(eachHeader.label)
//                   ? 'min-w-25px'
//                   : eachHeader.label === 'Recycler'
//                     ? 'min-w-150px'
//                     : 'min-w-125px'
//               }
//             />
//           )
//         },
//         id: idx + 1 + '',
//         Cell: ({ ...props }) => {
//           return ['S.N', 'ID'].includes(eachHeader.label) ? (
//             props.row.index + 1
//           ) : eachHeader?.label?.toLowerCase() === 'popular' ? (
//             <UserPopularCell
//               flag={props.data[props.row.index][eachHeader?.value] || false}
//               id={props.data[props.row.index].id}
//             />
//           ) : (
//             <UserInfoCell
//               mapData={eachHeader.value}
//               user={props.data[props.row.index]}
//               showImageOnly={eachHeader.value === 'avatar'}
//             />
//           )
//         },
//       }
//   })
// }

// // const columnGenerators: ReadonlyArray<Column<User>> = generator()
// const columnGenerators = (header) => {
//   return generator(header)
// }

// export { columnGenerators }
































// @ts-nocheck
import { Column } from 'react-table'
import { UserInfoCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserInfoCell'
import { UserLastLoginCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserLastLoginCell'
import { UserTwoStepsCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserTwoStepsCell'
import { UserActionsCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserActionsCell'
import { UserSelectionCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserSelectionCell'
import { UserCustomHeader } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserCustomHeader'
import { UserSelectionHeader } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserSelectionHeader'
import { boolean } from 'yup'
import { UserPopularCell } from '../../app/modules/apps/data-administration/data-admininstration-list/table/columns/UserPopularCell'

const generator = (data) => {
  return data.map((eachHeader, idx) => {
    if (eachHeader.label === 'certificate_view') {
      return {
        Header: (props) => (
          <UserCustomHeader tableProps={props} title={'Certificate'} className=' min-w-100px' />
        ),
        id: idx + 1 + '',
        Cell: ({ ...props }) => {
          return props?.data[props.row.index]?.status === 'Completed' ? (
            <UserActionsCell id={props.data[props.row.index].id} action={['view']} />
          ) : null
        },
      }
    } else if (eachHeader?.action?.length > 0) {
      return {
        Header: (props) => (
          <UserCustomHeader
            tableProps={props}
            title={eachHeader.action.includes('certificate') ? 'Certificate' : 'Actions'}
            className=' min-w-100px'
          />
        ),
        id: idx + 1 + '',
        Cell: ({ ...props }) => {
          const rowData = props.data[props.row.index];
          const currentPath = window.location.pathname;

          // For quality-assessment path, only show edit action if status is DISPATCHED
          if (currentPath === '/apps/transactions/quality-assessment' && eachHeader.action.includes('edit')) {
            return (
              <UserActionsCell
                allData={rowData}
                id={eachHeader?.action.includes('id') ? rowData.id : rowData}
                action={rowData.status === 'DISPATCHED' ? ['edit'] : []}
              />
            )
          }



          if (currentPath === '/apps/textile/textile-user-managment' && eachHeader.action.includes('edit')) {
            console.log('Textile path matched!'); // Add this
            console.log('Action:', eachHeader.action); // Add this
            return (
              <UserActionsCell
                allData={rowData}
                id={eachHeader?.action.includes('id') ? rowData.id : rowData}
                action={['edit']}
              />
            )
          }

          // For supply-orders2 path, only show edit action if status is DISPATCHED
          if (currentPath === '/apps/finance/supply-orders2' && eachHeader.action.includes('edit')) {
            return (
              <UserActionsCell
                allData={rowData}
                id={eachHeader?.action.includes('id') ? rowData.id : rowData}
                action={rowData.status === 'DISPATCHED' ? ['edit'] : []}
              />
            )
          }

          // For purchase collection-point path, never show edit action
          if (currentPath === '/apps/purchase/collection-point' && eachHeader.action.includes('edit')) {
            return (
              <UserActionsCell
                allData={rowData}
                id={eachHeader?.action.includes('id') ? rowData.id : rowData}
                action={['delete']}
              />
            )
          }

          // For business collection-point path, only show edit for ACTIVE status
          if (currentPath === '/apps/business/collection-point' && eachHeader.action.includes('edit')) {
            return (
              <UserActionsCell
                allData={rowData}
                id={eachHeader?.action.includes('id') ? rowData.id : rowData}
                action={rowData.status === 'ACTIVE' ? ['edit', 'delete'] : ['delete']}
              />
            )
          }

          // For finance collection-point path, only show edit for INACTIVE status
          if (currentPath === '/apps/finance/collection-point' && eachHeader.action.includes('edit')) {
            return (
              <UserActionsCell
                allData={rowData}
                id={eachHeader?.action.includes('id') ? rowData.id : rowData}
                action={rowData.status !== 'ACTIVE' ? ['edit', 'delete'] : ['delete']}
              />
            )
          }

          return (
            <UserActionsCell
              allData={props.data[props.row.index]}
              id={
                eachHeader?.action.includes('id')
                  ? props.data[props.row.index].id
                  : props.data[props.row.index]
              }
              action={eachHeader?.action}
            />
          )
        },
      }
    } else
      return {
        Header: (props) => {
          const currentPath = window.location.pathname;

          // Check if the current path is any of the supply orders pages
          const isSupplyOrdersPage = [
            '/apps/finance/supply-orders2',
            '/apps/logic/supply-orders',
            '/apps/purchase/supply-orders',
            '/apps/sales/supply-orders'
          ].includes(currentPath);

          // Only apply special handling on supply orders pages
          if (isSupplyOrdersPage) {
            // Reduced width for Qty, Item, and Date columns
            if (eachHeader.label === 'Qty' || eachHeader.label === 'Item' ||
              eachHeader.label === 'qty' || eachHeader.label === 'item' ||
              eachHeader.label === 'Date' || eachHeader.label === 'date') {
              return (
                <UserCustomHeader
                  tableProps={props}
                  title={eachHeader.label}
                  className="min-w-50px !w-50px"
                />
              )
            }

            // Increased width for Supply Partner column
            if (eachHeader.label === 'Supply partner' || eachHeader.label === 'Supply Partner') {
              return (
                <UserCustomHeader
                  tableProps={props}
                  title={eachHeader.label}
                  className="min-w-200px !w-200px"
                />
              )
            }
          }

          // Default column width handling
          return (
            <UserCustomHeader
              tableProps={props}
              title={eachHeader.label}
              className={
                ['S.N', 'ID'].includes(eachHeader.label)
                  ? 'min-w-25px'
                  : eachHeader.label === 'Recycler'
                    ? 'min-w-150px'
                    : 'min-w-125px'
              }
            />
          )
        },
        id: idx + 1 + '',
        Cell: ({ ...props }) => {
          return ['S.N', 'ID'].includes(eachHeader.label) ? (
            props.row.index + 1
          ) : eachHeader?.label?.toLowerCase() === 'popular' ? (
            <UserPopularCell
              flag={props.data[props.row.index][eachHeader?.value] || false}
              id={props.data[props.row.index].id}
            />
          ) : (
            <UserInfoCell
              mapData={eachHeader.value}
              subValue={eachHeader.subValue}
              valueLeft={eachHeader.valueLeft}
              valueRight={eachHeader.valueRight}
              user={props.data[props.row.index]}
              showImageOnly={eachHeader.value === 'avatar'}
            />
          )
        },
      }
  })
}

// const columnGenerators: ReadonlyArray<Column<User>> = generator()
const columnGenerators = (header) => {
  return generator(header)
}

export { columnGenerators }